import { useEffect } from 'react';
import { apiRequest } from '@cancercentrum/inca';
import { useDispatch } from 'react-redux';
import { RegisterActions } from '../../store/register/slice';
export const RegisterDocumentation = (props)=>{
    const { registerId, children } = props;
    const dispatch = useDispatch();
    useEffect(()=>{
        apiRequest(`/Registers/${registerId}/RegisterVariables/Documentation`).then((result)=>{
            dispatch(RegisterActions.addRegisterVariableDocumentation(result));
        });
    }, [
        registerId,
        dispatch
    ]);
    return children;
};
